import { Helmet } from 'react-helmet-async'
import { APP_CONSTANTS } from 'src/consumer/constants'

export const CANONICAL_ORIGIN = 'https://aumhum.com'

export default function SEOComponent({
  title,
  description,
  image,
  keywordsArr,
  pathname,
  canonical,
  type = 'website',
  locale = 'en_IN',
  noIndex = false,
  jsonLd,
  twitterSite,
  twitterCreator,
}) {
  const keywords = new Set([
    ...(Array.isArray(keywordsArr) ? keywordsArr : []),
    ...(APP_CONSTANTS.DEFAULT_KEYWORDS || []),
  ])
  const titleString = title || APP_CONSTANTS.DEFAULT_TITLE
  const descriptionString = description || APP_CONSTANTS.DEFAULT_DESCRIPTION
  const imageLink = image || APP_CONSTANTS.APP_LOGO_LINK
  const resolvedPathname = pathname || (
    typeof window !== 'undefined' && window.location ? window.location.pathname : '/'
  )
  const canonicalUrl = canonical || (
    `${CANONICAL_ORIGIN}${resolvedPathname.startsWith('/') ? resolvedPathname : `/${resolvedPathname}`}`
  )
  const jsonLdList = jsonLd
    ? (Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : [jsonLd])
    : []

  return (
    <Helmet>
      <title>{titleString}</title>
      <meta name="description" content={descriptionString} />
      <meta name="keywords" content={Array.from(keywords).join(', ')} />
      <meta
        name="robots"
        content={noIndex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large, max-snippet:-1'}
      />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:site_name" content="AUMHUM" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={titleString} />
      <meta property="og:description" content={descriptionString} />
      <meta property="og:image" content={imageLink} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:locale" content={locale} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={titleString} />
      <meta name="twitter:description" content={descriptionString} />
      <meta name="twitter:image" content={imageLink} />
      {twitterSite ? <meta name="twitter:site" content={twitterSite} /> : null}
      {twitterCreator ? <meta name="twitter:creator" content={twitterCreator} /> : null}
      {jsonLdList.map((obj, index) => (
        <script key={`jsonld-${index}`} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  )
}
